<template>
    <div class="compter-page">
        <MainHeader></MainHeader>
        <div class="main">
            <div class="container">
                <div class="detail-wrap">
                    <div class="detail-rich computer-rich">
                        <p class="16" align="center" style="text-align:center;white-space:normal;">
                            <span style=" font-size:24pt;">金盾机考系统刷题建议</span><span style=" font-size:18pt;">
                             </span>
                        </p>
                        <p class="16" align="center" style="text-align:left;white-space:normal;">
                            <span style=" font-size:18pt;">&nbsp;</span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（一）</span><span style=" font-size:14pt;"><span style=" ">建议从自己自主复习时，无论从大几开始，都可以先从专项知识点学起。在学习开始前，先做</span>2-3套套题，分析下自己每个模块的正确率，初步查找下自己的弱势模块。（可以注册金盾机考系统，免费体验做一套题）</span><span style=" font-size:14pt;">
                                
                            </span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（二）<strong>前期</strong></span><span style=" font-size:14pt;"><strong>以纸质版为主</strong></span><span style=" font-size:14pt;"><strong>，</strong></span><span style=" font-size:14pt;"><strong>做</strong></span><span style=" font-size:14pt;"><strong>专项题目</strong>。整理错题集，举一反三消化错题。尤其是大部分同学都薄弱的常识和数量模块。</span><span style=" font-size:14pt;">一定</span><span style=" font-size:14pt;">先</span><span style=" font-size:14pt;">从纸质版就打好基础。</span><span style=" font-size:14pt;">先纸质</span><span style=" font-size:14pt;">版</span><span style=" font-size:14pt;">不限时，再到纸质版限时，再往机考过度。</span><span style=" font-size:14pt;">
                               
                            </span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（三）</span><span style=" font-size:14pt;">每年</span><span style=" font-size:14pt;">金盾</span><span style=" font-size:14pt;">机考</span><span style=" font-size:14pt;">系统</span><span style=" font-size:14pt;">都会进行</span><span style=" font-size:14pt;">更新，</span><span style=" font-size:14pt;">购买金盾机考系统成为会员后，会员</span><span style=" font-size:14pt;">可以根据自己的薄弱模块开始用电脑训练。这里前提是一定经过了第二条的积累</span><span style=" font-size:14pt;">，</span><span style=" font-size:14pt;">避免浪费机考题目练习机会。因为</span><span style=" font-size:14pt;">机考系统里的</span><span style=" font-size:14pt;">题目做一遍以后就不能再做了。</span><span style=" font-size:14pt;">做题</span><span style=" font-size:14pt;"><span style=" ">顺序可以因人而异，在</span><strong>10月之前都可以刷专项</strong>。资料弱就多刷资料，言语弱就多刷言语。这个坚持<strong>一周2-3次训练</strong>。</span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（四）到10月份往后，基本复习进入水深火热的阶段，这个时候</span><span style=" color:#000000;font-size:14pt;">知觉与速度每天都要坚持练习</span><span style=" font-size:14pt;"><span style="color:#000000;">。</span>最初训练的前一周，一天3套，每次做完间隔5-10分钟，消化总结属于自己的问题点，再刷第二套。当刷到正确率在58道左右时，以后每天坚持刷一套保持手感即可</span><span style=" font-size:14pt;">。</span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（五）</span><span style=" font-size:14pt;"><strong>10月份以后，专项稳定后，可以刷套题了</strong>，坚持一周2-3套。刷套题时，结合联考最新考情，可选随机顺序。刷完要做错题分析。同时结合第一轮的错题集进行整合消化。</span><span style=" font-size:14pt;">
                                
                            </span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（六）</span><span style=" font-size:14pt;"><strong>12月下旬保持一天一套</strong></span><span style=" font-size:14pt;"><strong>真题</strong></span><span style=" font-size:14pt;">，保持真题题感。</span><span style=" font-size:14pt;">建议做题时间同步联考考试时间。培养生物钟</span>
                        </p>
                        <p class="16" style="white-space:normal;">
                            <span style=" font-size:14pt;">（七）</span><span style="font-size:18px;"><strong>要学会建立错题集</strong></span><span style=" font-size:14pt;"><span style="font-size:18px;"><strong>，</strong></span><strong>复盘错题进行总结</strong>，充分利用已考列表的错题回顾。</span><span style=" font-size:14pt;">
                                
                            </span>
                        </p>
                        <p class="MsoNormal" style="text-align:left;margin:0pt 0pt 0.0001pt;font-family:Calibri;font-size:10.5pt;white-space:normal;">
                            <span style="font-size:10.5pt;">&nbsp;</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MainHeader from '@/components/MainHeader.vue'
export default {
    components: {
        MainHeader
    },

}
</script>



<style lang="scss" scoped>
.compter-page {
    height: calc(100% - 37px);
    overflow: auto;

    .main {
        padding: 20px 40px;
        border-radius: 5px;
        background-color: #fff;
        max-width: 1200px;
        width: 100%;
        margin: 0 auto;
        height: calc(100% - 10px);
        overflow-y: auto;
        box-shadow: 0px 12px 20px 0px rgba(193, 193, 193, 0.7);
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        p{
            padding: 10px 0;
            // font-size: 14px;
            span{
                
            font-size: 14pt;
            }
            strong{
                font-weight: bold;
                font-size: 14pt;
            }
        }
    }
}</style>